import {
  BaseBillDto,
  BaseBillRequest
} from './bills-v4.model';
import {CommodityType} from '../_zen-legacy-common/_models/commodity';

/**
 * Gas units mapped to platform unitId.
 * Mirrors com.zentility.api.enums.GasUnitType (api-core).
 */
export enum GasUnitType {
  DTH = 3,
  TH = 4,
  MMBTU = 5,
  CCF = 6,
  MCF = 7,
  GJ = 8,
  M3 = 9,
}

/** GasUnitType enum name (e.g. "DTH", "CCF") as returned by the API. */
export type GasUnitName = keyof typeof GasUnitType;

/** Display labels for gas units (e.g. for the unit-normalization warning tooltip). */
export const GAS_UNIT_LABEL: Record<GasUnitName, string> = {
  DTH: 'Dth',
  TH: 'Therm',
  MMBTU: 'MMBtu',
  CCF: 'Ccf',
  MCF: 'Mcf',
  GJ: 'GJ',
  M3: 'm³',
};

export interface GasBillUsageInformation {
  totalUsage: number;
  totalUsagePlatform: number;
}

export interface GasBillSupplyInformation {
  supplyCharges: number;
  contractCharges: number;
  supplyCustomerCharges: number;
  supplyGasCharges: number;
  supplyOffPeakCharges: number;
  supplyRateClassCharges: number;
  supplyMisc: number;
  supplyGrtSut: number;
  contractedRate: number;
  totalSupplyRate: number;
  supplyProviderRate: number;
  supplyTax: number;
  supplyTotal: number;
}

export interface GasBillDistributionInformation {
  distributionCharges: number;
  distributionCustomerCharges: number;
  distributionGasCharges: number;
  distributionDeliveryCharges: number;
  distributionOffPeakCharges: number;
  distributionBalancingCharges: number;
  distributionRateClassCharges: number;
  distributionMisc: number;
  distributionGrtSut: number;
  distributionRate: number;
  distributionTotalRate: number;
  distributionTax: number;
  distributionTotal: number;
}

export interface GasBillDto extends BaseBillDto {
  // Literal discriminator for BillDto narrowing. Populated client-side in BillsV4GasService.
  commodityType: CommodityType.Gas;
  usageInformation?: GasBillUsageInformation;
  supplyInformation?: GasBillSupplyInformation;
  distributionInformation?: GasBillDistributionInformation;
}

export interface GasBillRequest extends BaseBillRequest,
  GasBillUsageInformation, GasBillSupplyInformation, GasBillDistributionInformation {}

export interface GasBillCreateRequest extends GasBillRequest {
  createdByUserId: string;
}

export interface GasBillUpdateRequest extends GasBillRequest {
  id: number;
}
